import { PayloadAction } from '@reduxjs/toolkit';
import dotPropImmutable from 'dot-prop-immutable';
import { uniqBy } from 'lodash';
import { Comment } from 'api/conversations';
import { ConversationStore, ConversationContext } from '../types';

export const commentSlice = {
  createComment: (
    state: ConversationStore,
    {
      payload,
    }: PayloadAction<{
      context: ConversationContext;
      comment: Comment;
    }>,
  ): ConversationStore => {
    const { context, comment } = payload;
    const path = `${context.type}-${context.id}.comments`;
    const comments = dotPropImmutable.get(state, path, []);

    return dotPropImmutable.set(
      state,
      path,
      uniqBy([...comments, comment], 'commentGuid'),
    );
  },

  updateComment: (
    state: ConversationStore,
    {
      payload,
    }: PayloadAction<{
      context: ConversationContext;
      comment: Comment;
    }>,
  ): ConversationStore => {
    const { context, comment } = payload;

    const path = `${context.type}-${context.id}.comments`;
    const comments = dotPropImmutable.get(state, path, []);

    return dotPropImmutable.set(
      state,
      path,
      uniqBy(
        comments.map((_comment) => {
          return _comment.commentGuid === comment.commentGuid
            ? { ..._comment, ...comment }
            : _comment;
        }),
        'commentGuid',
      ),
    );
  },

  deleteComment: (
    state: ConversationStore,
    {
      payload,
    }: PayloadAction<{
      context: ConversationContext;
      comment: Comment;
    }>,
  ): ConversationStore => {
    const { context, comment } = payload;

    const path = `${context.type}-${context.id}.comments`;
    const comments = dotPropImmutable.get(state, path, []);

    return dotPropImmutable.set(
      state,
      path,
      comments.filter((_comment) => {
        return _comment.commentId !== comment.commentId;
      }),
    );
  },
};
